<template>
  <div>
    <el-dialog
      custom-class="login-page-pc"
      width='500px'
      title=""
      :visible.sync="dialogVisible"
      :close-on-press-escape="true"
      :close-on-click-modal="true"
      :before-close="stopPolling"
      :append-to-body="true"
      :lock-scroll="false"
      top="0">
        <img class="background" :src="background" alt="">
        <div class="loading-qrcode" v-loading="loading">
          <img id="qr-code" :src="qrcode" alt="">
        </div>
    </el-dialog>
   <!-- 电脑端验证手机号码的弹窗 -->
    <CheckDialog
      :dialogVisible="pcCheckDialogVisible"
      @closeDialog="pcCheckDialogVisible = false"
      :headIcon="headIcon">
    </CheckDialog>
  </div>
</template>
<script>
import { scholarGetQrcode, wechatPolling } from '@/api/index'
import background from '@/assets/login_dialog_pc.png'
import CheckDialog from '@/components/CheckDialog'

export default {
  inject: ['reload'],
  props: {
    dialogVisible: Boolean
  },
  data () {
    return {
      qrcode: null,
      loading: true,
      background: background,
      pcCheckDialogVisible: false,
      headIcon: null
    }
  },
  methods: {
    requestQrcode () {
      scholarGetQrcode({app: 'scholar', action: 'pc_login_scholar'})
        .then((data) => {
          this.qrcode = data.data.qrcode_img_url
          this.ticket = data.data.ticket
          this.loading = false
          // 每隔一秒轮询一次
          window.timer = setInterval(function () {
            wechatPolling({
              ticket: this.ticket
            })
              .then((data) => {
                if (data.data) {
                  clearInterval(window.timer)
                  var wechatInfo = data.data.user
                  this.headIcon = wechatInfo.avatar
                  localStorage.setItem('scholar_wechat_info', JSON.stringify(wechatInfo))
                  let profile = data.data.profile
                  if (profile === null) {
                    this.$emit('closeDialog')
                    this.pcCheckDialogVisible = true
                  } else if (Number(profile.mobile_checked) === 0) {
                    this.$emit('closeDialog')
                    this.pcCheckDialogVisible = true
                  } else {
                    location.href = `${this.$route.params.id}`
                  }
                }
              })
              .catch((err) => { console.log(err) })
          }.bind(this), 1000)
        })
        .catch((err) => { console.log(err) })
    },
    stopPolling () {
      this.$emit('closeDialog')
      clearInterval(window.timer)
    }
  },
  watch: {
    dialogVisible: function (newValue, oldValue) {
      if (newValue === true) {
        this.requestQrcode()
      }
    }
  },
  components: {
    CheckDialog
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>
<style lang="scss">
  .el-dialog__wrapper .el-dialog.login-page-pc {
    background: none;
    box-shadow: none;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginDialog/index.vue